<template>
  <div v-loading="dataLoading" class="transaction-detail-wrapper">
    <template v-if="detailsData">
      <div class="detail-top">
        <div class="title-txt margin-bottom-16">{{ $t('message.settlement.refuseAmount') }}</div>
        <div class="amount-box">
          <p>
            <span class="amount-txt">{{ detailsData.chargebackAmount ? detailsData.chargebackAmount : '' }}</span>
            <span class="currency-txt">{{ detailsData.chargebackCurrency ? detailsData.chargebackCurrency : '' }}</span>
          </p>
          <div style="display: flex;">
            <!-- 接受拒付 -->
            <p style="margin-right: 8px"
              v-if="(detailsData.chargebackStatus === 'FAF' || detailsData.chargebackStatus === 'NEW')" class="btn-box"
              @click="acceptRebut">
              <span class="margin-left-4">{{ $t('message.tableCommon.acceptDishonor') }}</span>
            </p>
            <p v-if="(detailsData.chargebackStatus === 'FAF' || detailsData.chargebackStatus === 'NEW')" class="btn-box"
              @click="onRebut(false)">
              <img class="icon normal" src="@/assets/images/base/icon-doc.png" />
              <img class="icon active" src="@/assets/images/base/icon-doc-active.png" />
              <span class="margin-left-4 rebut-btn" v-if="detailsData.cardType === 'Klarna'">
                {{ detailsData?.appealInfo?.draft ? $t('message.refuse.klarnaRebutDrawer.continueRebut') :
                  $t('message.tableCommon.appeal') }}
              </span>
              <span class="margin-left-4" v-else>
                {{ $t('message.tableCommon.appeal') }}
              </span>
            </p>
            <p v-else-if="detailsData.chargebackStatus !== 'ACCEPT'" class="btn-box" @click="onRebut(true)">
              <img class="icon normal" src="@/assets/images/base/icon-doc.png" />
              <img class="icon active" src="@/assets/images/base/icon-doc-active.png" />
              <span class="margin-left-4">{{ $t('message.refuse.viewRebuttal') }}</span>
            </p>
          </div>
        </div>
        <div class="txn-info">
          <div class="txn-item-box margin-right-32">
            <p class="label">{{ $t('message.tableCommon.status') }}</p>
            <p class="value">
              <span :class="['status', `status-${detailsData.chargebackStatus}`]">{{ setChargebackStatus(detailsData)
                }}</span>
            </p>
          </div>
          <div class="txn-item-box margin-right-32">
            <p class="label">{{ $t('message.tableCommon.merchantOrderNumber') }}</p>
            <p class="value">
              <TextView :text="detailsData.externalOrderId" type="copy"></TextView>
            </p>
          </div>
          <div class="txn-item-box margin-right-32">
            <p class="label">{{ $t('message.refuse.arn') }}</p>
            <p class="value">{{ detailsData.chargebackArn }}</p>
          </div>
          <div class="txn-item-box">
            <p class="label">{{ $t('message.refuse.appealCountdown') }}</p>
            <p class="value">{{ getCountdownTime() }}</p>
          </div>
        </div>
      </div>
      <!-- 拒付信息 -->
      <div class="margin-top-32">
        <RhcnDescriptions :details-condition="refuseCondition"></RhcnDescriptions>
      </div>
      <!-- 交易信息 -->
      <div class="margin-top-32">
        <RhcnDescriptions :details-condition="txnCondition"></RhcnDescriptions>
      </div>
      <!-- 支付信息 -->
      <div class="margin-top-32">
        <RhcnDescriptions :details-condition="paymentCondition"></RhcnDescriptions>
      </div>
      <!-- 退款信息 -->
      <div class="margin-top-32">
        <rhcn-card-v2 :title="$t('message.refuse.refundInformation')">
          <template #body>
            <el-table :data="refundList" style="width: 100%;">
              <el-table-column v-for="column in tableCondition" :key="column.key" :prop="column.key"
                :label="$t(column.titleBar.title)">
                <template slot-scope="scope">
                  <span>{{ column.textFunc ? column.textFunc(scope.row) : scope.row[column.key] }}</span>
                </template>
              </el-table-column>
            </el-table>
          </template>

        </rhcn-card-v2>
      </div>

    </template>

    <custom-message ref="customMessage"></custom-message>

    <!-- klarna 专属抗辩 -->
    <klarna-rebut-drawer ref="klarnaRebutDrawerRef" style="height: 100vh;" @success="initMethod"></klarna-rebut-drawer>
  </div>
</template>
<script>
import RhcnDescriptions from '@/components/form/descriptions.vue';
import TextView from '@/components/form/text-view.vue';
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowWarningMessage } from '@/components/modal/tips/message-tips';
import RhcnCardV2 from '@/componentsV2/base-cmps/card/index.vue';
import { IS_PERMISSION_BUTTON } from '@/store/modules/permission';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData, splicingAmountAndCurrency } from '@/utils/tools/constant';
import { formatCardNumber } from '@/utils/tools/utils';
import { checkPermission } from '@/views/index/api/index';
import AppealService from '@/views/transaction/api/appeal-manage.service';
import TransitionService from '@/views/transaction/api/transaction-query.service';
import KlarnaRebutDrawer from '@/views/transaction/refuse-manage/klarna-rebut/index.vue';
export default {
  components: {
    RhcnDescriptions,
    CustomMessage,
    TextView,
    KlarnaRebutDrawer,
    RhcnCardV2,
  },
  data() {
    return {
      dataLoading: false,
      getTransactionDetails: TransitionService.getTransactionDetails,
      refuseId: '',
      txnTypeList: [],
      txnStatusList: [],
      refundStatusList: [],
      chargebackStatusList: [],
      txnCondition: {},
      refuseCondition: {},
      paymentCondition: {},
      refundCondition: {},
      getEnantiomericValue,
      detailsData: null,
      showRefund: false,
      isQueryHistory: false,
      statusList: [],
      countryList: [],
      txnInfo: null,
      refundList: [],
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.settlement.txnAmount' },
          type: 'text',
          key: 'txnAmount',
          textFunc: (data) => splicingAmountAndCurrency(data.txnAmount && data.txnAmount.currency, data.txnAmount && data.txnAmount.amount),
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.refundAmount' },
          type: 'text',
          key: 'refundAmount',
          textFunc: (data) => splicingAmountAndCurrency(data.refundAmount && data.refundAmount.currency, data.refundAmount && data.refundAmount.amount),
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.refundTime' },
          type: 'text',
          key: 'applyTime',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.refundAuditTime' },
          type: 'text',
          key: 'auditTime',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.refundDate' },
          type: 'text',
          key: 'refundTime',
        },
      ],
    };
  },
  methods: {
    acceptRebut() {
      this.$refs.customMessage.openHttpModal({
        titleHtml: this.$t('message.common.prompt'),
        contentHtml: this.$t('message.refuse.refuseAcceptTips'),
        httpFunction: AppealService.postAcceptAppeal,
        params: { id: this.detailsData.id },
        successFunction: this.initMethod,
      });
    },
    getRefuseTemplate(allData) {
      return {
        topTitle: 'message.refuse.refuseInfo',
        listTemplate: [
          {
            titleBar: { title: 'message.refuse.refuseId' },
            key: 'id',
          },
          {
            titleBar: { title: 'message.refuse.code' },
            key: 'chargebackCode',
          },
          {
            titleBar: { title: 'message.tableCommon.txnType' },
            key: 'txnType',
            textFunc: () => this.$t('message.status.refuse'),
          },
          {
            titleBar: { title: 'message.refuse.reason' },
            key: 'chargebackReason',
          },
          {
            titleBar: { title: 'message.settlement.refuseAmount' },
            key: 'refuseAmount',
            textFunc: (data) => splicingAmountAndCurrency(data.chargebackCurrency, data.chargebackAmount),
          },
          {
            titleBar: { title: 'message.tableCommon.auditOpinion' },
            key: 'auditOpinion',
            textFunc: (data) => {
              if (data.chargebackStatus === 'FA' || data.chargebackStatus === 'SA') {
                return '--';
              }
              return data.auditOpinion || '--';
            },
          },
          {
            titleBar: { title: 'message.refuse.receivedTime' },
            key: 'createTime',
          },
          {
            titleBar: { title: '' },
            key: 'placeholder',
            type: 'placeholder',
          },
          {
            titleBar: { title: 'message.refuse.date' },
            key: 'chargebackDate',
          },
          {
            titleBar: { title: '' },
            key: 'placeholder1',
            type: 'placeholder',
          },
          {
            titleBar: { title: 'message.refuse.dueDate' },
            key: 'chargebackDueDate',
          },
        ],
        data: allData,
      };
    },
    getTxnTemplate(allData) {
      return {
        topTitle: 'message.transaction.info',
        listTemplate: [
          {
            titleBar: { title: 'message.tableCommon.txnSerialNumber' },
            key: 'originTxnId',
            type: 'text-view',
            textViewType: 'link',
            onLink: () => {
              const params = {
                id: allData.originTxnId,
              };
              this.$router.push({
                path: '/transaction/details',
                query: params,
              });
            },
          },
          {
            titleBar: { title: 'message.tableCommon.txnType' },
            key: 'txnType',
            textFunc: (data) => getEnantiomericValue(this.txnTypeList, data.txnType),
          },
          {
            titleBar: { title: 'message.transaction.txnProcessTime' },
            key: 'txnDate',
          },
          {
            titleBar: { title: 'message.tableCommon.txnStatus' },
            key: 'txnStatus',
            textFunc: (data) => getEnantiomericValue(this.txnStatusList, data.txnStatus),
          },
          {
            titleBar: { title: 'message.tableCommon.txnAmount' },
            key: 'txnAmount',
            textFunc: (data) => splicingAmountAndCurrency(data.orderCurrency, data.orderAmount),
          },
          {
            titleBar: { title: '' },
            key: 'placeholder',
            type: 'placeholder',
          },
          {
            titleBar: { title: 'message.tableCommon.refundedAmount' },
            key: 'refundAmount',
            textFunc: (data) => splicingAmountAndCurrency(this.txnInfo?.refundedAmount.currency, this.txnInfo?.refundedAmount.amount),
          },
          {
            titleBar: { title: '' },
            key: 'placeholder',
            type: 'placeholder',
          },
          {
            titleBar: { title: 'message.tableCommon.merchantOrderNumber' },
            key: 'externalOrderId',
          },
          {
            titleBar: { title: '' },
            key: 'placeholder',
            type: 'placeholder',
          },
          {
            titleBar: { title: 'message.tableCommon.website' },
            key: 'website',
          },
        ],
        data: allData,
      };
    },
    getPaymentInfoTemplate(allData) {
      return {
        topTitle: 'message.transaction.paymentDetails',
        listTemplate: [
          {
            titleBar: { title: 'message.tableCommon.productType' },
            key: 'productType',
          },
          {
            titleBar: { title: 'message.tableCommon.cardBinCountry' },
            key: 'cardBinCountry',
            textFunc: (data) => data.cardBinCountry ? getEnantiomericValue(this.countryList, data.cardBinCountry) : '--',
          },
          {
            titleBar: { title: 'message.tableCommon.subProductType' },
            key: 'subProductType',
          },
          {
            titleBar: { title: 'message.tableCommon.ip' },
            key: 'ip',
          },
          {
            titleBar: { title: 'message.tableCommon.cardType' },
            key: 'cardBin',
          },
          {
            titleBar: { title: 'message.tableCommon.userAgent' },
            key: 'userAgent',
          },
          {
            titleBar: { title: 'message.tableCommon.bankCardNo' },
            key: 'cardNumber',
            textFunc: (data) => formatCardNumber(data.cardNumber),
          },
          {
            titleBar: { title: '' },
            key: 'placeholder',
            type: 'placeholder',
          },
        ],
        data: allData,
      };
    },
    async fetchTransactionDetail() {
      await AppealService.getChargebackInfo(this.refuseId).then((res) => {
        const data = res.chargeback;
        this.txnInfo = res.txnInfo;
        this.refundList = res.refundList;
        this.detailsData = data;
        this.txnCondition = this.getTxnTemplate(data);
        this.refuseCondition = this.getRefuseTemplate(data);
        this.paymentCondition = this.getPaymentInfoTemplate(res.txnInfo || {});
      });
    },
    async initDetailsAll() {
      this.txnCondition = this.getTxnTemplate({});
      this.refuseCondition = this.getRefuseTemplate({});
      this.paymentCondition = this.getPaymentInfoTemplate({});
      this.dataLoading = true;
      try {
        await this.fetchTransactionDetail();
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    setChargebackStatus(data) {
      return getEnantiomericValue(this.chargebackStatusList, data.chargebackStatus);
    },
    amountJudgment(params) {
      if (!this.detailsData || !this.detailsData.refundAmount || +this.detailsData.refundAmount.amount - +params.amount < 0) {
        ShowWarningMessage(this.$t('message.transaction.maximumRefundAmount') + this.detailsData.refundAmount.amount);
        return false;
      }
      return true;
    },
    getAmountDisplay(data) {
      if (data) {
        return splicingAmountAndCurrency(data.currency, data.amount);
      }
      return '';
    },
    async initMethod() {
      this.refuseId = this.$route.query.id;
      checkPermission('transaction:list:refund').then((res) => {
        this.showRefund = res;
      });
      await GlobalData.getDictList(['TXN_TYPE', 'MERC_TXN_STATUS', 'MERC_REFUND_STATUS', 'MERC_CHARGEBACK_STATUS', 'COUNTRY']).then((res) => {
        this.txnTypeList = initSelectedData(res.TXN_TYPE);
        this.txnStatusList = initSelectedData(res.MERC_TXN_STATUS);
        this.refundStatusList = initSelectedData(res.MERC_REFUND_STATUS);
        this.chargebackStatusList = initSelectedData(res.MERC_CHARGEBACK_STATUS);
        this.countryList = (res.COUNTRY || []).map(item => {
          try {
            const lang = this.$store.getters.app.currentLan;
            const arr = item.description.split('-');
            const label = lang === 'zh-cn' ? arr[0] : (arr[1] || arr[0]);
            return {
              label,
              value: item.value,
            };
          } catch (err) {
            //
          }
          return {
            label: item.description,
            value: item.value,
          };
        });
      }).catch(() => {
      });
      this.initDetailsAll();
      this.isQueryHistory = this.$route.query.isHistory === '1';
    },
    /**
     * 刷新当前表单
     */
    getCountdownTime() {
      if (this.detailsData.chargebackStatus === 'FA') {
        return '--';
      }
      const countdownTime = this.detailsData.countdownTime;
      if (countdownTime) {
        const days = Math.floor(countdownTime / (1000 * 60 * 60 * 24)); // 计算天数
        if (days >= 1) {
          return this.$t('message.subscription.frequencyData.D', { day: days });
        } else {
          const hours = Math.floor(countdownTime / (1000 * 60 * 60) % 24); // 计算小时数
          const surplusHours = countdownTime / (1000 * 60 * 60) % 24 - hours;
          const minutes = Math.floor(surplusHours * 60); // 计算分钟数
          return this.$t('message.subscription.frequencyData.H', { hour: hours }) + ' ' +
            this.$t('message.subscription.frequencyData.M', { minute: minutes });
        }
      } else {
        return '--';
      }
    },
    onRebut(isView) {
      // if (this.detailsData.cardType === 'Klarna') {
      //   this.$refs.klarnaRebutDrawerRef.open(this.detailsData?.id, isView);
      // } else {
      //   if (isView) {
      //     this.$router.push({ path: '/transaction/refuse/view', query: { id: this.detailsData.id } });
      //   } else {
      //     this.$router.push({ path: '/transaction/refuse/appeal', query: { id: this.detailsData.id } });
      //   }
      // }

      if (this.detailsData.chargebackStatus === 'FAF') {
        this.$refs.customMessage.openHttpModal({
          titleHtml: this.$t('message.refuse.secondAppealConfirm'),
          contentHtml: this.$t('message.refuse.secondAppealConfirmTips'),
          confirmFuntion: () => {
            if (this.detailsData.cardType === 'Klarna') {
              this.$refs.klarnaRebutDrawerRef.open(this.detailsData?.id, isView);
            } else {
              if (isView) {
                this.$router.push({ path: '/transaction/refuse/view', query: { id: this.detailsData.id } });
              } else {
                this.$router.push({ path: '/transaction/refuse/appeal', query: { id: this.detailsData.id } });
              }
            }
          },
        });
      } else {
        if (this.detailsData.cardType === 'Klarna') {
          this.$refs.klarnaRebutDrawerRef.open(this.detailsData?.id, isView);
        } else {
          if (isView) {
            this.$router.push({ path: '/transaction/refuse/view', query: { id: this.detailsData.id } });
          } else {
            this.$router.push({ path: '/transaction/refuse/appeal', query: { id: this.detailsData.id } });
          }
        }
      }

      // if (isView) {
      //   this.$router.push({ path: '/transaction/refuse/view', query: { id: this.detailsData.id } });
      // } else {
      //   if (isView) {
      //     this.$router.push({ path: '/transaction/refuse/view', query: { id: this.detailsData.id } });
      //   } else {
      //     this.$router.push({ path: '/transaction/refuse/appeal', query: { id: this.detailsData.id } });
      //   }
      // }

      // if (isView) {
      //   this.$router.push({ path: '/transaction/refuse/view', query: { id: this.detailsData.id } });
      // } else {
      //   this.$router.push({ path: '/transaction/refuse/appeal', query: { id: this.detailsData.id } });
      // }
    },
  },
  mounted() {
    this.initMethod();
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.transaction-detail-wrapper {
  padding-bottom: 50px;

  :deep(.rhcn-descriptions) {
    .el-descriptions-item__label {
      width: 120px;
      min-width: 120px;
    }
  }
}

html[lang=en] .transaction-detail-wrapper {
  :deep(.rhcn-descriptions) {
    .el-descriptions-item__label {
      width: 160px;
      min-width: 160px;
    }
  }
}

.detail-top {
  margin-bottom: 30px;
  border-radius: 8px;
  border: 1px solid #EFEFF4;
  padding: 24px;

  .title-txt {
    font-size: 14px;
    font-family: Avenir-Book, Avenir;
    font-weight: normal;
    color: $color-description-new;
    line-height: 19px;
    border-bottom: 1px solid #EFEFF4;
    padding-bottom: 16px;
  }

  .amount-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 7px;
    margin-bottom: 15px;
    color: $color-text-primary-new;
    font-weight: 800;

    .amount-txt {
      font-size: 32px;
      line-height: 30px;
      margin-right: 10px;
    }

    .currency-txt {
      color: #667085;
      font-size: 32px;
      font-weight: 400;
    }

    .currency-icon {
      width: 26px;
      margin-right: 38px;
    }

    .status {
      font-size: 14px;
      line-height: 30px;
      padding: 0 8px;
      height: 30px;
      border-radius: 4px;
      background: rgba(252, 100, 45, 0.15);

      &-S {
        background: rgba(0, 221, 40, 0.15);
      }

      &-P,
      &-U {
        background: rgba(255, 178, 9, 0.15);
      }

      &-N {
        background: #F1F5F7;
      }
    }

    .btn-box {
      display: flex;
      align-items: center;
      padding: 0 24px;
      height: 26px;
      border-radius: 8px;
      border: 1px solid #D0D5DD;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      line-height: 18px;
      cursor: pointer;

      .icon {
        width: 12px;
        height: 12px;

        &.active {
          display: none;
        }
      }

      &:hover {
        background: #F6F6FF;
        border: 1px solid $color-primary-new;
        color: $color-primary-new;

        .icon.normal {
          display: none;
        }

        .icon.active {
          display: inline-block;
        }
      }
    }
  }

  .txn-info {
    display: flex;

    .txn-item-box {
      flex: 1;
      border-right: 1px solid #EFEFF4;

      &:last-child {
        border-right: none;
      }

      .label {
        font-weight: 400;
        font-size: 14px;
        color: #667085;
        line-height: 18px;
        margin-bottom: 8px;
      }

      .value {
        font-weight: 400;
        font-size: 14px;
        color: $color-text-primary-new;
        line-height: 18px;
      }
    }

    .status {
      font-weight: bold;
      font-size: 12px;
      line-height: 30px;
      padding: 2px 8px;
      height: 20px;
      border-radius: 20px;
      background: #FFFAEB;
      color: #CC8406;

      &-S,
      &-ACCEPT,
      &-SAS,
      &-FAS,
      &-pass {
        background: #ECFDF3;
        color: #027A48;
      }

      &-F,
      &-SAT,
      &-SAF,
      &-FAT,
      &-FAF,
      &-fail {
        background: #FEF3F2;
        color: #912018;
      }

      &-N,
      &-REVOKE {
        background: #EBEEF1;
        color: #667085;
      }
    }
  }
}

.timeline-box {
  .timeline-item {
    position: relative;
    display: flex;
    align-items: flex-start;
    min-height: 56px;
    padding-bottom: 16px;

    .timeline-item-icon {
      position: relative;
      width: 9px;
      height: 9px;
      border: 1px solid #D9D9D9;
      border-radius: 50%;
      z-index: 1;
    }

    .timeline-item-content {
      .timeline-item-title {
        font-weight: bold;
        font-size: 16px;
        color: $color-black;
        line-height: 16px;
      }

      .timeline-item-time {
        font-weight: 400;
        font-size: 12px;
        color: #9EA9C1;
        line-height: 20px;
      }

      .timeline-item-link {
        //
      }
    }

    .time-line {
      position: absolute;
      left: 5px;
      top: 13px;
      height: 62px;
      border-left: 1px solid #EFEFF4;
      z-index: 0;
    }

    &:last-child {
      padding-bottom: 0;

      .time-line {
        height: 10px;
      }
    }
  }
}
</style>
